import { H4,H5, H6 } from '../../../AbstractElements';
import React, { Fragment } from 'react';
import { CardHeader } from 'reactstrap';
import { Target, Info, CheckCircle, PlusCircle } from 'react-feather';
import { Add, Cancel,pinagareAPIURL } from '../../../Constant';

const HeaderCard = ({ title, span1, span2, mainClasses, eng , pdfdata}) => {
  
  return (
    <Fragment>
      { eng=="pending"?(
      <CardHeader  style={{color:'#6ec6ec', backgroundColor:"#52aad036"}}>
        <H6 style={{color:'#6ec6ec'}}>
       <Target /> 
      {title}</H6>
        {span1 ? <span>{span1}</span> : ''}
        {span2 ? <span>{span2}</span> : ''}
      </CardHeader>) :( eng=="rejected_candidates"?(
         <CardHeader  style={{color:'red', backgroundColor:"#d59f9f2e"}}>
         <H6 style={{color:'red'}}>
        <span style={{textAlign: 'left'}}>
       {title} </span>
       </H6>

      {pdfdata!=null&&pdfdata.length>0? (<span style={{textAlign: 'right'}}> 
       <a href={`${pinagareAPIURL}?generate_pinagare_list_pdf=true&eng=`+eng+`&application_details=`+JSON.stringify(pdfdata)} target="_blank"><H6><span style={{color:"#414b41"}}>{" View As (PDF)"}</span></H6></a>			 
       </span>):null}
         {span1 ? <span>{span1}</span> : ''}
         {span2 ? <span>{span2}</span> : ''}
       </CardHeader>
      ):( eng=="approved_candidates"?(
        <CardHeader style={{color:'green', backgroundColor:"#76957659"}}>
        <H6 style={{color:'green'}}>
        <span style={{textAlign: 'left'}}>
      {title}</span>
        </H6>
      
        {pdfdata!=null&&pdfdata.length>0? (<span style={{textAlign: 'right'}}> 
       <a href={`${pinagareAPIURL}?generate_pinagare_list_pdf=true&eng=`+eng+`&application_details=`+JSON.stringify(pdfdata)} target="_blank"><H6><span style={{color:"#414b41"}}>{" View As (PDF)"}</span></H6></a>			 
       </span>):null}
        {span1 ? <span>{span1}</span> : ''}
        {span2 ? <span>{span2}</span> : ''}
      </CardHeader>
     ):(eng=="qualifying_candidates"?(
      <CardHeader style={{color:'#be820a', backgroundColor:"#e2e3e5"}}>
      <H6 style={{color:'#be820a'}}>
      <span style={{textAlign: 'left'}}>
    {title}</span>
      </H6>
    
      {pdfdata!=null&&pdfdata.length>0? (<span style={{textAlign: 'right'}}> 
       <a href={`${pinagareAPIURL}?generate_pinagare_list_pdf=true&eng=`+eng+`&application_details=`+JSON.stringify(pdfdata)} target="_blank"><H6><span style={{color:"#414b41"}}>{" View As (PDF)"}</span></H6></a>			 
       </span>):null}
      {span1 ? <span>{span1}</span> : ''}
      {span2 ? <span>{span2}</span> : ''}
    </CardHeader>
   ):( eng=="withdrawn_applications"?(
    <CardHeader  style={{color:'brown', backgroundColor:"#b6a6856b"}}>
    <H6 style={{color:'brown'}}>
    <span style={{textAlign: 'left'}}>
  {title}</span>
    </H6>
  
    {pdfdata!=null&&pdfdata.length>0? (<span style={{textAlign: 'right'}}> 
       <a href={`${pinagareAPIURL}?generate_pinagare_list_pdf=true&eng=`+eng+`&application_details=`+JSON.stringify(pdfdata)} target="_blank"><H6><span style={{color:"#414b41"}}>{" View As (PDF)"}</span></H6></a>			 
       </span>):null}
    {span1 ? <span>{span1}</span> : ''}
    {span2 ? <span>{span2}</span> : ''}
  </CardHeader>
 ): (
      <CardHeader style={	{color:'#000000', backgroundColor:"#52aad036"}	}>
        <H6 style={{color:'#000000'}}>      
      {title}</H6>
        {span1 ? <span>{span1}</span> : ''}
        {span2 ? <span>{span2}</span> : ''}
      </CardHeader>)))))

      }

    </Fragment>
  );
};

export default HeaderCard;
